import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import TierBadge from "@/components/TierBadge";

// Custom high-contrast marker
const icon = new L.DivIcon({
  className: "",
  html: `<div style="width:32px;height:32px;border-radius:50% 50% 50% 0;background:#2563EB;border:3px solid #111827;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.3)">
           <div style="transform:rotate(45deg);color:white;font-weight:800;font-size:14px">A</div>
         </div>`,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -30],
});

export default function VenueMap({ venues, height = 520 }) {
  const withCoords = venues.filter(v => typeof v.lat === "number" && typeof v.lng === "number");
  const center = withCoords[0] ? [withCoords[0].lat, withCoords[0].lng] : [51.5544, -1.7823]; // Swindon

  return (
    <div className="rounded-xl border-2 border-gray-900 overflow-hidden" style={{ height }}>
      <MapContainer center={center} zoom={10} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {withCoords.map(v => (
          <Marker key={v.id} position={[v.lat, v.lng]} icon={icon}>
            <Popup>
              <div className="min-w-[200px]">
                <div className="font-heading font-semibold text-base">{v.venue_name}</div>
                <div className="text-xs text-gray-600 mb-2">{v.area} · {v.category}</div>
                {(v.rating_count || 0) > 0 || v.tier
                  ? <TierBadge points={v.rating} tier={v.tier} />
                  : <span className="text-xs text-gray-500">Awaiting inspection</span>}
                <div className="mt-2">
                  <Link to={`/venue/${v.id}`} className="text-blue-600 font-medium text-sm">View profile →</Link>
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
